export default "__VITE_ASSET__CzJD_qr5__"